// eslint-disable-next-line banned-modules
'use strict';

import './style.less';
import Widget from '@/widgets/base.widget';
import template from './template.ejs';
import suggestionTemplate from './suggestion.ejs';
import selectedItemTemplate from './selectedItem.ejs';
import 'corejs-typeahead/dist/typeahead.jquery';
import $ from 'jquery';

import BaseCollection from '@/classes/base.collection';
import BaseModel from '@/classes/base.model';

const MultipleSelectModel = BaseModel.extend({
	idAttribute: 'uid',
});

const MultipleSelectCollection = BaseCollection.extend({
	model: MultipleSelectModel,
});

const MultipleSelect = Widget.extend({

	template,

	viewName: 'b-multiple-select',

	ui: {
		selected: '.b-multiple-select__selected',
		all: '.b-multiple-select',
		popup: '.b-multiple-select__popup',
		ctrl: '.b-multiple-select__label',
	},

	events: {
		'click .b-multiple-select__label,.b-multiple-select__select': 'onLabelClicked',
		'focus .b-multiple-select__input': 'onFocus',
		'blur .b-multiple-select__input': 'onBlur',
		'typeahead:beforeclose': 'typeaheadBeforeClose',

		'mousedown .b-multiple-select__label,.b-multiple-select__select': 'onLabelMouseDown',
		'mousedown .b-multiple-select__selected': 'selectedItemMouseDown',
		'mousedown .b-multiple-select__item-code': 'removeSelected',
	},

	lastClick: '',

	initialize(options) {
		this.options = options;
		this.placeholder = options.placeholder || L10N.get('widgets.selectItem');
		this.values = MultipleSelect.getStoreCollection(options.values).toJSON();
		this.selectedItems = [];
		this.lastSelectedItem = '';
		this.render();
		this.$typeahead = this.getElements('input');
		this.$typeahead.typeahead(
			{
				hint: false,
				highlight: false,
				minLength: 0,
				limit: 1,
				classNames: {
					menu: 'b-multiple-select__items',
					wrapper: 'b-multiple-select__wrapper',
					input: 'b-multiple-select__input',
					hint: 'b-multiple-select__hint',
					dataset: 'b-multiple-select__dataset',
					suggestion: 'b-multiple-select__item',
					selectable: 'b-multiple-select__selectable',
					empty: 'b-multiple-select__empty',
					open: 'b-multiple-select__open',
					cursor: 'b-multiple-select__cursor',
					highlight: 'b-multiple-select__highlight',
				},
			},
			{
				name: 'multipleSelect',
				limit: 25,
				source: (q, cb) => {
					const selected = this.selectedItems;
					cb(this.values.reduce((result, item) => {
						if (item && item.caption && item.caption.toUpperCase().includes(q.toUpperCase())) {
							if (_.isEmpty(selected) || !selected.find(el => el.uid === item.uid)) result.push(item);
						}
						return result;
					}, []));
				},
				display: ' get display ',
				async: true,
				templates: {
					suggestion: suggestionTemplate,
				},
			});
	},

	applyBinding(model) {
		if (!this.model.get(this.options.bindingProperty)) {
			this.model.set(this.options.bindingProperty, []);
		}

		this.$typeahead.on('typeahead:select', (ev, suggestion) => {
			let modelItems = model.get(this.options.bindingProperty);
			this.lastSelectedItemUid = suggestion.uid;
			if (!modelItems.find(element => element.uid === suggestion.uid)) {
				modelItems = modelItems.concat({
					uid: suggestion.uid,
					caption: `${suggestion.caption}`,
				});
				model.set(this.options.bindingProperty, modelItems);
			}
			this.lastClick = 'suggestion';
		});

		this.listenTo(model, `validationError:${this.options.bindingProperty}`, () => {
			this.$el.addClass('validation-error');
		});

		this.listenTo(model, `change:${this.options.bindingProperty}`, (__model, values) => {
			this.ui.selected.empty();
			if (!values) {
				return;
			}
			values.forEach(item => {
				this.ui.selected.append(selectedItemTemplate(item));
			});
			this.selectedItems = values;

			this.showSelectedItemsCount();
			this.changeSuggestedItemsVisibility();
		});
		model.trigger(`change:${this.options.bindingProperty}`, model, model.get(this.options.bindingProperty));
	},

	changeSuggestedItemsVisibility() {
		const suggestions = this.$el.find(`[data-uid]`);
		const selectedSuggestions = _.filter(suggestions, (el) => {
			return _.find(this.selectedItems, item => item.uid === $(el).attr('data-uid'));
		});
		const unselectedSuggestions = _.filter(suggestions, (el) => selectedSuggestions.indexOf(el) === -1);
		$(selectedSuggestions).addClass('dn');
		$(unselectedSuggestions).removeClass('dn');
	},

	displaySuggestions() {
		this.$typeahead.val('').trigger('input');
	},

	removeSelected(e) {
		const uid = this.$(e.currentTarget).attr('uid');
		this.lastSelectedItemUid = uid;
		this.model.set(this.options.bindingProperty, this.model.get(this.options.bindingProperty).filter(item => item.uid !== uid));
		this.lastClick = 'remove';
		this.displaySuggestions();
	},

	onBlur() {
		if (!(this.lastClick === 'remove')) {
			this.hideSelected();
			this.$el.removeClass('open');
		} else {
			setTimeout(() => {
				this.$typeahead.focus();
			}, 0);
		}
	},

	hideSelected() {
		this.ui.popup.hide();
	},

	showSelectedItemsCount() {
		const value = this.model.get(this.options.bindingProperty);
		if (!value || value.length === 0) {
			this.ui.ctrl.html(`${this.placeholder}`);
			this.$el.removeClass('active');
			return;
		}
		this.selectedItems = value;
		this.$el.addClass('active');
		const selectedValues = value.reduce((prev, cur) => {
			prev.push(cur.caption);
			return prev;
		}, []).join(', ');
		this.ui.ctrl.html(selectedValues);
	},

	typeaheadBeforeClose() {
		if (this.lastClick === 'remove') {
			this.lastClick = '';
			return false;
		}
		if (this.lastClick === 'suggestion') {
			this.lastClick = '';
			return false;
		}
		return true;
	},

	onLabelClicked() {
		if (this.$el.hasClass('open') || this.lastClick === 'label') {
			this.$el.removeClass('open');
			this.lastClick = '';
			return;
		}
		this.$el.addClass('open');
		this.ui.popup.show();
		this.$typeahead.focus();
	},

	onLabelMouseDown() {
		if (this.$el.hasClass('open')) {
			this.lastClick = 'label';
		}
	},

	selectedItemMouseDown() {
		this.lastClick = 'remove';
	},

}, {
	dictionaryToCollection(data) {
		return new MultipleSelectCollection(data);
	},

	arrayToCollection(data) {
		return MultipleSelect.dictionaryToCollection(data);
	},

	storeCollection(collection) {
		if (!MultipleSelect.stores) {
			MultipleSelect.stores = {};
		}
		if (!MultipleSelect.stores[collection.cid]) {
			MultipleSelect.stores[collection.cid] = collection;
		}
		return collection.cid;
	},

	getStoreCollection(cid) {
		return MultipleSelect.stores[cid];
	},
});

export default MultipleSelect;
